import React from "react";

function InstagramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width="30"
      height="30"
      fill="#007200"
    >
      <defs>
        <linearGradient id="greenGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#004d00", stopOpacity: 1 }} />{" "}
          {/* Dark green */}
          <stop
            offset="100%"
            style={{ stopColor: "#00e600", stopOpacity: 1 }}
          />{" "}
          {/* Light green */}
        </linearGradient>
      </defs>
      <path
        fill="url(#greenGradient)"
        d="M384.004,80.011v0.805v31.179c0,8.844,7.172,16,16.001,16h31.196
h0.805c8.828,0,16.008,7.176,16.008,16.004c0,8.844-7.18,16.004-16.008,16.004h-40.002c-20.977,0-38.017-16.219-39.688-36.777
c-0.086-1.078-0.32-2.117-0.32-3.23V80.011c0-8.848,7.18-16.004,16-16.004C376.84,64.007,384.004,71.164,384.004,80.011
L384.004,80.011z M127.996,271.994c0-8.82,7.157-16,16-16c8.829,0,16,7.18,16,16c0,8.844-7.172,16.008-16,16.008
C135.153,288.002,127.996,280.838,127.996,271.994L127.996,271.994z M256,384.009c-34.782,0-66.252-13.898-89.323-36.414
c-3.57-2.93-5.921-7.344-5.921-12.344c0-8.828,7.164-15.999,15.984-15.999c4.43,0,8.414,1.789,11.321,4.694l0.055-0.055
c17.368,17.391,41.368,28.109,67.885,28.109c48.416,0,88.314-35.858,94.917-82.444l0.125,0.016
c1.383-8.648,9.406-14.656,18.102-13.398c8.743,1.273,14.806,9.383,13.548,18.141c-0.125,0.844-0.359,1.641-0.609,2.438
C372.145,337.563,319.611,384.009,256,384.009L256,384.009z M495.999,288.002c-8.828,0-15.984-7.164-15.984-16.008
c0-8.82,7.156-16,15.984-16c8.845,0,16.001,7.18,16.001,16C512,280.838,504.844,288.002,495.999,288.002L495.999,288.002z
M416.005,512H95.995C42.985,512,0,469.023,0,415.993V255.994c0-35.339,28.649-63.992,63.986-63.992h8.008h56.001
c10.477,0,19.79-5.039,25.642-12.844c0.141-0.18,0.32-0.285,0.484-0.43c23.352-30.8,60.236-50.734,101.878-50.734
c41.635,0,78.525,19.934,101.878,50.734c0.164,0.145,0.344,0.25,0.484,0.43c5.852,7.805,15.165,12.844,25.642,12.844h64.01
c17.664,0,32.001-14.332,32.001-32v-5.887v-26.121V96.011c0-35.359-28.665-64.007-64.01-64.007H95.995
c-35.345,0-63.994,28.648-63.994,64.007v31.984v16.004c0,8.844-7.172,16.004-16,16.004c-8.844,0-16-7.16-16-16.004V96.011
C0,42.984,42.985,0,95.995,0h320.01C469.014,0,512,42.984,512,96.011v47.988v16.004c0,35.339-28.649,64.003-63.986,64.003h-64.01
c-20.923,0-39.486-10.042-51.166-25.562c-0.094-0.125-0.219-0.145-0.305-0.25c-17.492-23.195-45.228-38.191-76.533-38.191
c-31.29,0-59.064,14.996-76.534,38.191c-0.094,0.105-0.219,0.125-0.305,0.25c-11.665,15.52-30.243,25.562-51.166,25.562h-64.01
c-17.665,0-31.985,14.316-31.985,31.988v159.999C32.001,451.352,60.65,480,95.995,480h320.01c35.345,0,64.01-28.648,64.01-64.007
v-79.992c0-8.844,7.156-15.999,15.984-15.999c8.845,0,16.001,7.155,16.001,15.999v79.992C512,469.023,469.014,512,416.005,512
L416.005,512z"
      />
    </svg>
  );
}

export default InstagramIcon;
